module.exports = __webpack_public_path__ + "static/media/mono-flat-logo.a4327f6c.svg";